<ifm-application-form
    [data]="data"
    [form]="form"
    [documents]="docs"
    [isInProgress]="isInProgress"
    [parentObjectId]="currentId"
    (saveFormAction)="saveFormHandler($event)"
    (saveFilesAction)="saveFilesHandler($event)"
    (saveAllAction)="saveAllHandler($event)"
    (submitAction)="submitHandler($event)"
  ></ifm-application-form>